<template>
  <div class="hero" v-if="items.length">
    <div class="hero__slide">
      <Slider
        :value="items"
        :display-thumbnail="true"
        :manual-navigation="true"
        :captionPlacement="'outside'"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ScrollIntoView } from '@/utils'
import Slider from '@kvass/media-render/Slider'

export default {
  props: {
    description: {
      type: String,
    },
    images: {
      type: Array,
      default: () => [],
    },
    hideStats: Boolean,
  },
  computed: {
    ...mapState('Root', ['item']),
    items() {
      return this.images
    },
    keyInfo() {
      return this.$path('item.customFields.key-info') || []
    },
  },
  methods: {
    gotoInfo() {
      ScrollIntoView('.section__info', -document.querySelector('.nav').clientHeight)
    },
    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY / 4
        document.body.style.setProperty('--parallax-top', `${scrollTop}px`)
      })
    },
  },
  metaInfo() {
    return {
      link: [...this.items.map(item => ({ rel: 'preload', as: 'image', href: item }))],
    }
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.onScroll)
  },
  components: {
    Slider,
  },
}
</script>

<style lang="scss">
.hero {
  $height: 64vh;
  top: 1.2rem;
  position: relative;
  height: $height;
  width: 100%;
  background-color: css-alpha('primary', 0.1);

  iframe {
    min-height: $height;
  }

  @include respond-below('tablet') {
    height: 64vh;
    iframe {
      min-height: 64vh;
    }
  }

  @include respond-below('phone') {
    height: 100vh;
    iframe {
      min-height: 100vh;
    }
  }

  .kvass-media-render-slider iframe {
    min-width: 300vh;
    height: 300vh !important;
  }

  &__slide {
    position: relative;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    iframe {
      min-height: $height;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 500ms;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
